import { ChangeDetectionStrategy, Component, EventEmitter, input, InputSignal, Output, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AddToCartModel, ProductModel } from '@libs/shop/models';
import { ViewportService } from '@libs/shared/services';
import { AddToCartFormResult } from '../elements';

@Component({
  selector: 'ui-product-detail-form-base',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductDetailFormBaseComponent {
  @Output()
  public addToShoppingList: EventEmitter<AddToCartModel<ProductModel>> = new EventEmitter<AddToCartModel<ProductModel>>();

  public product: InputSignal<ProductModel> = input.required();
  public isMobile: Signal<boolean>;

  public constructor(
    private readonly viewportService: ViewportService,
  ) {
    this.isMobile = toSignal(this.viewportService.isMobile(), { initialValue: false });
  }

  public onAddToShoppingList(result: AddToCartFormResult): void {
    this.addToShoppingList.emit({ item: this.product(), quantity: result.productQuantity });
  }
}
